// extracted by mini-css-extract-plugin
export default {"Butterfly":"Butterfly-module__Butterfly__M9CcLO6"};